var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { SongTimeline } from "./SongTimeline";
import { TrackList } from "./TrackList.js";
import { NoteUITrack, SoundFileUITrack } from "../Shared/UITrack.js";
import { VerticalScrollView } from "../Shared/VerticalScrollView.js";
import { UIPositioning } from "../Settings/UITheme";
import { navigationView } from "../Shared/NavigationView";
import { SequencerView } from "../Sequencer/SequencerView";
import { Dropdown } from "../SharedReact/BasicElements";
import { UITrackStore } from "../ReactUI/UITrackStore";
export class TimelineView extends VerticalScrollView {
    constructor(width, height, songManager) {
        super(width, height);
        this._sidebarPosition = UIPositioning.timelineSidebarWidth;
        this._songManager = songManager;
        this.interactive = true;
        this.showSequencer = this.showSequencer.bind(this);
        this.addedHandler = this.addedHandler.bind(this);
        this.removedHandler = this.removedHandler.bind(this);
        this._trackEdited = this._trackEdited.bind(this);
        this._UITrackUpdateHandler = this._UITrackUpdateHandler.bind(this);
        this.on("added", this.addedHandler);
        this.on("removed", this.removedHandler);
        this.trackList = new TrackList(this._sidebarPosition, width, height, songManager);
        this.trackList.trackEdited.addListener(this._trackEdited);
        this.addChild(this.trackList);
        this.timeline = new SongTimeline(this._sidebarPosition, width, height, songManager, this.showSequencer);
        this.addChild(this.timeline);
        this._newTrackDropdownContainer = document.createElement("div");
        document.getElementById("applicationContainer").appendChild(this._newTrackDropdownContainer);
        Object.assign(this._newTrackDropdownContainer.style, {
            position: "absolute",
            top: "5px",
            left: "5px"
        });
        this._renderNewTrackObject();
        this._cleanupListener = UITrackStore.subscribe(this._UITrackUpdateHandler);
    }
    get contentHeight() {
        let tracks = UITrackStore.getState().tracks;
        if (tracks.length == 0) {
            return 0;
        }
        else {
            return tracks[tracks.length - 1].startY + tracks[tracks.length - 1].height;
        }
    }
    resize(width, height) {
        super.resize(width, height);
        this.trackList.resize(width, height);
    }
    destroy() {
        unmountComponentAtNode(this._newTrackDropdownContainer);
        document.getElementById("applicationContainer").removeChild(this._newTrackDropdownContainer);
        this.removeAllListeners();
        this._cleanupListener();
        super.destroy();
    }
    showSequencer(track, startPosition) {
        let sequencerView = new SequencerView(this.endX, this.endY, track, this._songManager, Math.floor(this.timeline.metadata.positionQuarterNoteToBars(startPosition)));
        navigationView.show(sequencerView);
    }
    addedHandler() {
        super.addedHandler();
        this.trackList.addedHandler();
        this._renderNewTrackObject();
    }
    removedHandler() {
        super.removedHandler();
        this.trackList.removedHandler();
        unmountComponentAtNode(this._newTrackDropdownContainer);
    }
    addOscillatorTrack() {
        let tracks = UITrackStore.getState().tracks;
        let track = this._songManager.addOscillatorTrack();
        let startY = this.contentHeight != 0 ? this.contentHeight : UIPositioning.timelineHeaderHeight;
        let settings = { name: "Track " + (tracks.length + 1).toString(), startY: startY, height: 250, modelTrackID: track.id, noteGroups: [] };
        UITrackStore.dispatch({ type: "ADD_TRACK", track: new NoteUITrack(settings, track) });
    }
    addSoundFileTrack() {
        return __awaiter(this, void 0, void 0, function* () {
            let tracks = UITrackStore.getState().tracks;
            let track = yield this._songManager.addSoundFileTrack();
            let startY = this.contentHeight != 0 ? this.contentHeight : UIPositioning.timelineHeaderHeight;
            let settings = { type: "soundFile", name: ("Track " + (tracks.length + 1).toString()), startY: startY, height: 250, displayActualWidth: true, modelTrackID: track.id };
            UITrackStore.dispatch({ type: "ADD_TRACK", track: new SoundFileUITrack(settings, track) });
        });
    }
    updateVerticalScroll(value) {
        value = Math.min(0, value);
        this.timeline.updateVerticalScroll(value);
        this.trackList.updateVerticalScroll(value);
    }
    _trackEdited(index) {
        let tracks = UITrackStore.getState().tracks;
        this.timeline.reinitialiseTrack(tracks[index]);
    }
    _UITrackUpdateHandler() {
        let tracks = UITrackStore.getState().tracks;
        if (tracks.length > 0) {
            let lastTrack = tracks[tracks.length - 1];
            let endHeight = lastTrack.startY + lastTrack.height + this.verticalScrollPosition;
            if (endHeight < this.endY) {
                this.verticalScrollPosition += (this.endY - endHeight);
            }
        }
        else {
            this.verticalScrollPosition = 0;
        }
        this._renderNewTrackObject();
    }
    _renderNewTrackObject() {
        let buttonClassName = "addTrackButton";
        if (UITrackStore.getState().tracks.length == 0) {
            buttonClassName += " highlight";
        }
        render(React.createElement(Dropdown, { title: "New Track", iconName: "fa fa-plus", optionTitles: ["New Oscillator Track", "New Sound File Track"], buttonClassName: buttonClassName, optionsDivClassName: "addTrackOptionsDiv", optionClassName: "addTrackItem", optionClickCallback: (index) => __awaiter(this, void 0, void 0, function* () {
                if (index == 0) {
                    this.addOscillatorTrack();
                }
                else if (index == 1) {
                    yield this.addSoundFileTrack();
                }
            }) }), this._newTrackDropdownContainer);
    }
}
//# sourceMappingURL=TimelineView.js.map